/**
 *  @class
 *  @function VideoControls
 */
if (!customElements.get('video-controls')) {
  class VideoControls extends HTMLElement {
    constructor() {
      super();
      this.hideTimeout = null;
    }

    connectedCallback() {
      this.video = this.closest('.shoppable-video-reels--video')?.querySelector('video');
      this.sound_toggle = this.querySelector('.video-controls--sound');
      this.play_toggle = this.querySelector('.video-controls--play-pause');

      if (!this.video || !this.play_toggle) return;

      this.setInitialState();
      this.setEventListeners();
    }

    setInitialState() {
      // Ensure video is paused on load
      this.video.pause();

      // Show play icon
      this.play_toggle.classList.add('paused');

      // Show controls initially
      this.classList.add('visible');
    }

    setEventListeners() {
      this.play_toggle.addEventListener('click', this.playPause.bind(this));

      if (this.sound_toggle) {
        this.sound_toggle.addEventListener('click', this.muteUnmute.bind(this));
      }

      // Hover behavior (show controls)
      this.parentElement.addEventListener('mouseenter', () => {
        this.showControls();
      });

      this.parentElement.addEventListener('mouseleave', () => {
        if (!this.video.paused) {
          this.startHideTimer();
        }
      });

      // Sync UI if video is controlled externally
      this.video.addEventListener('play', () => {
        this.play_toggle.classList.remove('paused');
        this.startHideTimer();
      });

      this.video.addEventListener('pause', () => {
        this.play_toggle.classList.add('paused');
        this.showControls();
        clearTimeout(this.hideTimeout);
      });
    }

    playPause(e) {
      if (this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }

      e.stopPropagation();
    }

    muteUnmute(e) {
      this.video.muted = !this.video.muted;

      if (this.video.muted) {
        this.sound_toggle.classList.add('muted');
      } else {
        this.sound_toggle.classList.remove('muted');
      }

      e.stopPropagation();
    }

    startHideTimer() {
      clearTimeout(this.hideTimeout);

      this.showControls();

      this.hideTimeout = setTimeout(() => {
        if (!this.video.paused) {
          this.hideControls();
        }
      }, 2500);
    }

    showControls() {
      this.classList.add('visible');
    }

    hideControls() {
      this.classList.remove('visible');
    }
  }

  customElements.define('video-controls', VideoControls);
}